import { InstrumentSpecificType } from './InstrumentSpecificType';
import { InteriorIdUtils } from './InteriorIdUtils';
export class InstrumentDescriptionUtils {
    static createInteriorId(instDescr) {
        var _a;
        return InteriorIdUtils.generateInteriorID(instDescr.id, instDescr.tradableId, (_a = instDescr.instrSpecificType) !== null && _a !== void 0 ? _a : InstrumentSpecificType.None, instDescr.routeId);
    }
    static createFromInteriorId(interiorId) {
        const { instrumentTradableID, routeId, id, instrumentSpecificType } = InteriorIdUtils.parseInteriorID(interiorId);
        if (instrumentTradableID === null || routeId === null)
            return null;
        return Object.assign({ id: id ? id.toString() : '', tradableId: instrumentTradableID, routeId: routeId }, (!isNullOrUndefined(instrumentSpecificType) && {
            instrSpecificType: instrumentSpecificType
        }));
    }
}
